import { useMemo } from 'react';
import { object, number, string, ObjectSchema, array } from 'yup';
import { useTranslation } from 'react-i18next';
import { STRING_MIN_LENGTH_DEFAULT, STRING_MAX_LENGTH_DEFAULT } from '@cbridge-utils/app';
import { useSelector } from '@cbridge-utils/react-redux';
import { CSV_SAFE_REGEX } from '@cbridge-utils/shared-helpers';
import { IMarkupProfile, markupProfileNamesSelector } from '@cbridge-packages/markup-profile';
import { IStreamBase } from '@cbridge-packages/stream';

export const useMarkupProfileFormSchema = (): ObjectSchema<IMarkupProfile> => {
  const { t } = useTranslation();

  const markupProfileNames = useSelector(markupProfileNamesSelector);

  return useMemo(() => {
    return object({
      markupProfileId: number().nullable(),
      markupProfileName: string()
        .trim()
        .label(t('text:entity.markupProfile.profileName.label'))
        .min(STRING_MIN_LENGTH_DEFAULT)
        .max(STRING_MAX_LENGTH_DEFAULT)
        .matches(CSV_SAFE_REGEX, t('text:validation.chars.csvUnsafe'))
        .required()
        .test('unique', t('text:validation.mustBeUnique', '', { field: t('text:entity.markupProfile.profileName.label') }), (value) => {
          if (!value) return true;
          return !markupProfileNames.has(value);
        }),
      streams: array<{}, IStreamBase>(),
    });
  }, [t, markupProfileNames]);
};
